import React from "react";
import { default as WPaper } from "@mui/material/Paper";

function Paper(props) {
  return <WPaper {...props} />;
}

export default Paper;
